import { Button, Dialog, Box, DialogContent, TextField, MenuItem, DialogActions, Tooltip } from '@material-ui/core'
import React, { useState, useEffect, useRef } from 'react'
import moment from 'moment';
import { useSnackbar } from 'notistack';
import AuthService from '../../../services/AuthService';
import EventIcon from '@material-ui/icons/Event';
import EditIcon from '@material-ui/icons/Edit';

moment.updateLocale('en', {
    weekdays: 'segunda_terça_quarta_quinta_sexta_sábado_domingo'.split('_'),
    weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
});


const temDiaSelecionado = (dia) => dia !== "" && dia !== null && dia !== undefined

export default function Agendamento({ configuracaoAgendamento, handleChangeDiaEHorario, selectedTimestampScheduleParam, diaAgendamentoParam, horaAgendamentoParam, tipoDelivery }) {
    const { enqueueSnackbar } = useSnackbar()
    const [open, setOpen] = useState(false)
    const [state, setState] = useState({
        selectedDay: temDiaSelecionado(diaAgendamentoParam) ? diaAgendamentoParam : "",
        selectedTime: horaAgendamentoParam || "",
        horarios: [],
        ErrorAgendamento: null,
        selectedTimestampSchedule: selectedTimestampScheduleParam || null
    })

    const prevTipoDeliveryRef = useRef(tipoDelivery)
    const sequenciaBuscaRef = useRef(0)

    useEffect(() => {
        const trocouModalidade = prevTipoDeliveryRef.current !== tipoDelivery
        prevTipoDeliveryRef.current = tipoDelivery

        const tinhaAgendamento = state.selectedTimestampSchedule !== null

        if (temDiaSelecionado(state.selectedDay)) {
            revalidarAgendamento(state.selectedDay, state.selectedTime, tinhaAgendamento)
        } else if (trocouModalidade && tinhaAgendamento) {
            descartarAgendamento("O agendamento não é válido para essa forma de entrega. Agende novamente.", [], "")
        }

        return invalidarBuscasPendentes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tipoDelivery])

    const getDiasPedido = () => {
        var maximoDias = configuracaoAgendamento.numeroMaximoDiasAgendamento;
        var arrayDias = [];

        const isRetirada = tipoDelivery === "RETIRAR_LOCAL" || tipoDelivery === "CONSUMIR_LOCAL";
        let jsonConfig = isRetirada && configuracaoAgendamento.jsonConfiguracaoRetirada
            ? JSON.parse(configuracaoAgendamento.jsonConfiguracaoRetirada)
            : JSON.parse(configuracaoAgendamento.jsonConfiguracao)

        const datasEspecificas = configuracaoAgendamento.jsonDatasEspecificas
            ? JSON.parse(configuracaoAgendamento.jsonDatasEspecificas)
            : []

        for (let index = 0; index <= maximoDias; index++) {
            let currentDate = moment().utc().add(index, 'days') /*Adicionado .utc para padronizar o horário */
            let weekDay = currentDate.isoWeekday();
            let configForCurrentDate = jsonConfig.find(elem => elem.dayOfWeek === weekDay)
            let existTimeForThis = configForCurrentDate.times.length > 0

            // Verifica se existe exceção para essa data específica
            // Prefere exceção específica da modalidade sobre AMBOS
            const dataFormatada = currentDate.format('YYYY-MM-DD')
            const excecaoEspecifica = datasEspecificas.find(ex => {
                if (ex.data !== dataFormatada) return false
                const modalidade = ex.modalidade || 'AMBOS'
                return (isRetirada && modalidade === 'RETIRADA') ||
                    (!isRetirada && modalidade === 'ENTREGA')
            })
            const excecaoAmbos = datasEspecificas.find(ex => {
                return ex.data === dataFormatada && (ex.modalidade || 'AMBOS') === 'AMBOS'
            })
            const excecao = excecaoEspecifica || excecaoAmbos

            if (excecao) {
                if (excecao.tipo === 'BLOQUEAR') {
                    existTimeForThis = false
                } else if (excecao.tipo === 'PERSONALIZAR') {
                    existTimeForThis = excecao.horarios && excecao.horarios.length > 0
                }
            }

            var obj = {
                label: "",
                dia: "",
                weekDay: weekDay,
                formatedDate: currentDate.format('DD/MM/YYYY'),
                enabled: existTimeForThis
            }
            if (arrayDias.length < 1) {
                obj.label = `${currentDate.format('DD/MM/YYYY ddd')} (hoje)`;
                obj.dia = index;
            } else if (arrayDias.length === 1) {
                obj.label = `${currentDate.format('DD/MM/YYYY ddd')} (amanhã)`;
                obj.dia = index;
            } else {
                obj.label = `${currentDate.format('DD/MM/YYYY ddd')} (daqui a ${index} dias)`;
                obj.dia = index;
            }

            arrayDias.push(obj);
        }

        return arrayDias;
    }

    const cancelarAgendamento = () => {
        handleChangeDiaEHorario(null, null)
        setState({
            selectedDay: "",
            horarios: [],
            selectedTime: "",
            selectedTimestampSchedule: null,
            ErrorAgendamento: null
        })
        //configuracaoAgendamento.situacao = "NA";
        setOpen(false)
    }

    const confirmarAgendamento = () => {
        if (!isValidoHorarioAgendamento()) {
            return
        }
    
        handleChangeDiaEHorario(state.selectedDay, state.selectedTime)
    
        diaAgendado()
        setOpen(false)
    }     

    const diaAgendado = () => {

        var hoje = new Date().toLocaleString("en-US", { timeZone: "America/Sao_Paulo" });
        var diaAgendamento = moment(hoje).utc().add(state.selectedDay, 'days') /*Adicionado .utc para padronizar o horário */
        var horarioArray = state.selectedTime.split(":");
        diaAgendamento.hour(horarioArray[0]);
        diaAgendamento.minute(horarioArray[1]);
        setState(prev => ({
            ...prev,
            selectedTimestampSchedule: diaAgendamento
        }))
    }

    const buscarHorarios = (dia) => {
        var hoje = new Date().toLocaleString("en-US", { timeZone: "America/Sao_Paulo" });
        var date = moment(hoje).utc().add(dia, 'days').format("YYYY-MM-DD HH:mm");

        var service = new AuthService();
        return service.post(`/configurarAgendamento/getHorarios`, { data: date, tipoDelivery: tipoDelivery || "ENTREGAR" })
    }

    const invalidarBuscasPendentes = () => {
        sequenciaBuscaRef.current++
    }

    const respostaAindaVale = (sequencia) => sequencia === sequenciaBuscaRef.current

    const erroAoBuscarHorarios = (err, sequencia, avisoNoSnackbar) => {
        console.error('ERRO AO BUSCAR HORÁRIOS DE AGENDAMENTO', err)

        if (!respostaAindaVale(sequencia)) {
            return
        }

        setState(prev => ({ ...prev, horarios: [], ErrorAgendamento: "Não foi possível carregar os horários. Tente novamente." }))

        if (avisoNoSnackbar) {
            enqueueSnackbar(avisoNoSnackbar, { variant: "warning" })
        }
    }

    const diaHabilitado = (dia) => {
        const opcao = getDiasPedido().find(elem => elem.dia === dia)

        return !!opcao && opcao.enabled
    }

    const descartarAgendamento = (mensagem, horarios, dia) => {
        handleChangeDiaEHorario(null, null)

        setState(prev => ({
            ...prev,
            selectedDay: dia,
            horarios,
            selectedTime: "",
            selectedTimestampSchedule: null,
            ErrorAgendamento: mensagem
        }))

        if (mensagem) {
            enqueueSnackbar(mensagem, { variant: "warning" })
        }
    }

    const revalidarAgendamento = (dia, horario, tinhaAgendamento) => {
        if (tinhaAgendamento && !diaHabilitado(dia)) {
            descartarAgendamento("O dia agendado não está disponível para essa forma de entrega. Escolha outro.", [], "")
            return
        }

        const sequencia = ++sequenciaBuscaRef.current

        setState(prev => ({ ...prev, horarios: [], ErrorAgendamento: null }))

        buscarHorarios(dia)
            .then(resp => {
                if (!respostaAindaVale(sequencia)) {
                    return
                }

                const horarios = resp.times || []

                if (horario && horarios.indexOf(horario) >= 0) {
                    setState(prev => ({ ...prev, horarios, selectedTime: horario, ErrorAgendamento: null }))
                    return
                }

                const mensagem = horarios.length > 0
                    ? "O horário agendado não está disponível para essa forma de entrega. Escolha outro."
                    : "Nenhum horário disponível para esse dia :("

                if (tinhaAgendamento) {
                    descartarAgendamento(mensagem, horarios, dia)
                    return
                }

                setState(prev => ({ ...prev, horarios, selectedTime: "", ErrorAgendamento: mensagem }))
            })
            .catch(err => erroAoBuscarHorarios(err, sequencia, "Não foi possível conferir os horários de agendamento. Confira antes de finalizar o pedido."))
    }

    const handleChangeDia = (newDay) => {

        if (!temDiaSelecionado(newDay)) {

            setState(prev => ({
                ...prev,
                selectedDay: "",
                horarios: [],
                selectedTime: ""
            }))
            return;
        }

        var dia = newDay;
        const sequencia = ++sequenciaBuscaRef.current

        setState(prev => ({ ...prev, selectedDay: dia, horarios: [], selectedTime: "", ErrorAgendamento: null }))

        buscarHorarios(dia)
            .then(resp => {
                if (!respostaAindaVale(sequencia)) {
                    return
                }

                if (!resp.times || resp.times.length === 0) {
                    setState(prev => ({
                        ...prev,
                        horarios: [],
                        selectedTime: "",
                        ErrorAgendamento: "Nenhum horário disponível para esse dia :("
                    }))
                } else {
                    setState(prev => ({
                        ...prev,
                        horarios: resp.times,
                        ErrorAgendamento: null
                    }))
                }
            })
            .catch(err => erroAoBuscarHorarios(err, sequencia))
    }

    const handleChangeHorario = (horario) => {
        setState(prev => ({ ...prev, selectedTime: horario, ErrorAgendamento: null }));
    }

    const isValidoHorarioAgendamento = () => {
        if (!state.selectedTime) {
            let mensagem = "Por favor, selecione um horário para continuar :)"
            setState(prev => ({ ...prev, ErrorAgendamento: mensagem }))

            return false
        }
        setState(prev => ({ ...prev, ErrorAgendamento: null }))
        return true
    }

    return (
        <Box display="flex" justifyContent="center">
            {configuracaoAgendamento ? (
                <React.Fragment>

                    {state.selectedTimestampSchedule !== null ? (
                        <Tooltip title="Editar agendamento" placement="top" arrow>
                            <Button onClick={() => setOpen(true)}
                                variant="outlined"
                                color="primary" startIcon={<EditIcon />} >
                                {state.selectedTimestampSchedule !== null ? moment(state.selectedTimestampSchedule).utc().format("DD/MM/YY HH:mm") : "Editar Agendamento" /*Adicionado .utc para padronizar o horário */}
                            </Button>
                        </Tooltip>
                    ) : (
                        <Button onClick={() => setOpen(true)}
                            variant="outlined"
                            color="primary" startIcon={<EventIcon />} >
                            {configuracaoAgendamento.situacao === "NA" ? "Deseja agendar seu pedido?" : "Agende seu pedido"}
                        </Button>
                    )}

                    <Dialog maxWidth="sm" fullWidth open={open} onClose={() => setOpen(false)} disableBackdropClick={true}>
                        <DialogContent>
                            <Box py={1}>
                                <TextField
                                    id="selecionarMunicipio"
                                    select
                                    label="Dia do agendamento"
                                    name="data"
                                    onChange={event => handleChangeDia(event.target.value)}
                                    fullWidth
                                    variant="outlined"
                                    value={state.selectedDay}
                                >
                                    <MenuItem disabled value={""}>
                                        - selecionar o dia -
                                    </MenuItem>
                                    {getDiasPedido().map((option) => (
                                        <MenuItem key={option.dia} value={option.dia} disabled={!option.enabled}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Box>

                            <Box py={1}>
                                <TextField
                                    id="selecionarHorario"
                                    select
                                    label="Selecione o horário"
                                    name="horario"
                                    onChange={event => handleChangeHorario(event.target.value)}
                                    fullWidth
                                    variant="outlined"
                                    helperText={state.ErrorAgendamento}
                                    error={!!state.ErrorAgendamento}
                                    value={state.selectedTime}
                                >
                                    <MenuItem disabled value={null}>
                                        - selecione o horário -
                                    </MenuItem>
                                    {state.horarios?.map((option) => (
                                        <MenuItem key={option} value={option} >
                                            {option}
                                        </MenuItem>
                                    ))}
                                </TextField>

                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color="primary"
                                size="small"
                                onClick={cancelarAgendamento}>
                                {configuracaoAgendamento.situacao === "A" ? "Remover" : "Cancelar"}
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={confirmarAgendamento}>
                                Confirmar
                            </Button>
                        </DialogActions>
                    </Dialog>
                </React.Fragment>
            ) : null
            }
        </Box >
    )
}
